module.exports = __webpack_public_path__ + "static/media/general-setting-w.dec3e01d.svg";